/* currency.js — تحويل الأسعار للعرض (2026-10-31)، نفس فكرة محوّل Kalles في الثيم المنشور.
   الأسعار تنكتب بالدولار من شوبيفاي، وهذا الملف يحوّلها في الصفحة للعملة المختارة (أسعار صرف شوبيفاي).
   الاختيار يُحفظ في localStorage (maktaba:currency). أول زيارة: العملة حسب بلد الزائر (browsing_context_suggestions). الدفع بالدولار. */
(function () {
  'use strict';
  var KEY = 'maktaba:currency', AUTO = 'maktaba:currency:auto', BASE = 'USD';
  var FLAG = { USD: 'us', BHD: 'bh', SAR: 'sa', KWD: 'kw', AED: 'ae', QAR: 'qa', OMR: 'om', IQD: 'iq', SYP: 'sy', LBP: 'lb' };
  var BY_COUNTRY = { BH: 'BHD', SA: 'SAR', KW: 'KWD', AE: 'AED', QA: 'QAR', OM: 'OMR', IQ: 'IQD', SY: 'SYP', LB: 'LBP' };
  var DEC = { BHD: 3, KWD: 3, OMR: 3, IQD: 0, SYP: 0, LBP: 0 };
  var AR = '٠١٢٣٤٥٦٧٨٩';
  var RE = /\$\s?([0-9٠-٩][0-9٠-٩,٬]*(?:[.٫][0-9٠-٩]+)?)(\s?USD)?/g;
  var SKIP = 'script,style,textarea,input,select,noscript,[data-cur-skip],.cur-sheet,.rte';
  var html = document.documentElement;
  var cur = BASE, rates = null, obs = null, queued = false;

  function store(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function read(k, s) { try { return (s ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } }
  function done() { html.classList.remove('cur-pending'); }

  function loadRates(cb) {
    if (window.Currency && Currency.rates) { rates = Currency.rates; return cb(); }
    var s = document.getElementById('CurrencyRates');
    if (!s) { s = document.createElement('script'); s.id = 'CurrencyRates'; s.src = '/cdn/s/javascripts/currencies.js'; s.async = true; document.head.appendChild(s); }
    var tries = 0;
    (function wait() {
      if (window.Currency && Currency.rates) { rates = Currency.rates; return cb(); }
      if (++tries > 100) { cur = BASE; done(); return; }
      setTimeout(wait, 50);
    })();
  }

  function toNum(str) {
    str = str.replace(/[٠-٩]/g, function (d) { return AR.indexOf(d); }).replace(/[,٬]/g, '').replace('٫', '.');
    return parseFloat(str);
  }
  function amount(num) {
    var usd = toNum(num);
    if (isNaN(usd) || !rates || !rates[cur]) return null;
    var dec = cur in DEC ? DEC[cur] : 2;
    var s = (usd * rates[BASE] / rates[cur]).toFixed(dec).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    s = s.join('.');
    if (/[٠-٩]/.test(num)) s = s.replace(/\d/g, function (d) { return AR[d]; });
    var v = document.createElement('span');
    v.className = 'cur-v';
    v.setAttribute('dir', 'ltr');
    if (s.length > 5) v.setAttribute('data-long', '');
    v.appendChild(document.createTextNode(s));
    var u = document.createElement('span');
    u.className = 'cur-u';
    u.textContent = cur;
    v.appendChild(u);
    return v;
  }
  // a text holding a dollar price becomes <span class="cur-amt" data-cur-usd="(original text)">…<span class="cur-v">3.756<span class="cur-u">BHD</span></span>…</span>
  function build(orig) {
    var box = document.createElement('span'), last = 0, m, hit = false;
    box.className = 'cur-amt';
    RE.lastIndex = 0;
    while ((m = RE.exec(orig))) {
      var v = amount(m[1]);
      if (!v) continue;
      hit = true;
      if (m.index > last) box.appendChild(document.createTextNode(orig.slice(last, m.index)));
      box.appendChild(v);
      last = RE.lastIndex;
    }
    if (!hit) return null;
    if (last < orig.length) box.appendChild(document.createTextNode(orig.slice(last)));
    box.setAttribute('data-cur-usd', orig);
    box.setAttribute('data-cur-code', cur);
    return box;
  }

  function apply(root) {
    root = root || document.body;
    if (!root) return;
    if (obs) obs.disconnect();
    html.classList.toggle('cur-alt', cur !== BASE);
    root.querySelectorAll('.cur-amt').forEach(function (el) {
      if (el.getAttribute('data-cur-code') === cur) return;
      var orig = el.getAttribute('data-cur-usd');
      var nb = cur === BASE ? null : build(orig);
      el.replaceWith(nb || document.createTextNode(orig));
    });
    if (cur !== BASE) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          var p = n.parentElement;
          if (!p || p.closest(SKIP) || p.closest('.cur-amt')) return NodeFilter.FILTER_REJECT;
          return /\$\s?[0-9٠-٩]/.test(n.data) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
      });
      var list = [], n;
      while ((n = walker.nextNode())) list.push(n);
      list.forEach(function (node) { var nb = build(node.data); if (nb) node.replaceWith(nb); });
    }
    watch();
  }
  function watch() {
    if (!obs) obs = new MutationObserver(function () {
      if (queued) return; queued = true;
      requestAnimationFrame(function () { queued = false; apply(); });
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function paintButtons() {
    var name = '';
    document.querySelectorAll('[data-cur-pick]').forEach(function (b) {
      var on = b.getAttribute('data-cur-pick') === cur;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) name = b.getAttribute('data-cur-name');
    });
    document.querySelectorAll('[data-cur-code]').forEach(function (s) { s.textContent = cur; });
    document.querySelectorAll('[data-cur-flag]').forEach(function (i) { i.src = 'https://cdn.shopify.com/static/images/flags/' + FLAG[cur] + '.svg'; });
    document.querySelectorAll('[data-cur-open]').forEach(function (b) { b.setAttribute('aria-label', 'اختر العملة: ' + name); });
  }

  function setCurrency(code, save) {
    if (!FLAG[code]) code = BASE;
    cur = code;
    if (save) store(KEY, code);
    paintButtons();
    if (code === BASE) { apply(); done(); return; }
    loadRates(function () { apply(); done(); });
    document.dispatchEvent(new CustomEvent('currency:change', { detail: { currency: code } }));
  }

  function sheet() { return document.getElementById('CurrencySheet'); }
  function openSheet() {
    var d = sheet(); if (!d) return;
    if (d.showModal) { if (!d.open) d.showModal(); } else d.setAttribute('open', '');
    var sel = d.querySelector('[aria-selected="true"]'); if (sel) sel.focus();
  }
  function closeSheet() { var d = sheet(); if (d && d.open) d.close(); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cur-open]')) { e.preventDefault(); openSheet(); return; }
    if (e.target.closest('[data-cur-close]')) { closeSheet(); return; }
    var pick = e.target.closest('[data-cur-pick]');
    if (pick) { setCurrency(pick.getAttribute('data-cur-pick'), true); closeSheet(); return; }
    var d = sheet();
    if (d && e.target === d) closeSheet(); // tap on the dimmed backdrop
  });

  function init() {
    var d = sheet(); // the sheet lives in the hidden menu drawer; move it to <body> so it also opens from the announcement bar
    if (d && d.parentElement !== document.body) document.body.appendChild(d);
    var saved = read(KEY);
    if (saved && FLAG[saved]) return setCurrency(saved, false);
    var auto = read(AUTO, true);
    if (auto && FLAG[auto]) return setCurrency(auto, false);
    fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        var code = BY_COUNTRY[c] || BASE;
        try { sessionStorage.setItem(AUTO, code); } catch (e) {}
        setCurrency(code, false);
      })
      .catch(function () { setCurrency(BASE, false); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
